module.exports = __webpack_public_path__ + "static/img/1.d558062.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/1.png
// module id = /Aof
// module chunks = 0